module.exports = __webpack_public_path__ + "img/益田分校@2x.de41d251.png";